import { Typography } from "@mui/material";
import React from "react";

/**
 * @author
 * @function EmptyState
 **/

interface EmptyStateProps {
  heading?: string;
  icon?: any;
  title?: string;
  description?: string;
  hasButton?: boolean;
  button?:any
  style?:any
}
export const EmptyState = (props: EmptyStateProps) => {
  const { heading, icon, title, description,style } = props;
  return (
    <div className="MO_emptyState" style={style}>
      <div className="heading">
        {heading}
      </div>
      <div className="content">
        <div>{icon}</div>
        <div className="title">{title}</div>
        <div className="description">{description}</div>
        {props?.hasButton && props?.button}
      </div>
    </div>
  );
};
